<template>
  <b-container fluid id="account-container" v-bind:class="$mq">
    <b-row>
      <b-col cols=6 class="account_details_card" v-bind:class="$mq" lg=4>
        <b-card id="meta"
                class="card_icon"
                v-bind:class="[$mq, advisory_level]">
          <AccountDetailsMeta v-bind:id="id"
                              v-bind:info="info"
                              v-bind:info_v2="info_v2" />
        </b-card>
      </b-col>

      <b-col cols=6 class="account_details_card" v-bind:class="$mq" lg=4>
        <b-card id="balances"
                class="card_icon"
                v-bind:class="$mq">
          <AccountDetailsBalances v-bind:balances="balances"
                                  v-bind:xchg_rates="xchg_rates" />
        </b-card>
      </b-col>

      <b-col lg=4 class="account_details_card last_card" v-bind:class="$mq">
        <b-card id="tags"
                class="card_icon"
                v-bind:class="$mq">
          <AccountDetailsTags v-bind:id="id" />
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-container fluid id="details_container">
          <b-row>
            <b-col style="margin: 10px;" v-bind:style="{'font-size': $mq == 'sm' ? '0.75em' : '1.2em'}">
              Account: <b>{{id}}</b>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div class="spinner_container" v-if="loading">
                <b-spinner />
              </div>
            </b-col>
          </b-row>


          <b-row no-gutters style="align-items: center;">
            <b-col v-bind:cols="$mq == 'sm' ? 10 : 8">
              <b-nav tabs id="account_sections" v-bind:class="$mq">
                <b-nav-item v-bind:active="section == 'txs'"
                            v-on:click="set_section('txs')">
                  Transactions
                </b-nav-item>

                <b-nav-item v-bind:active="section == 'tls'"
                            v-on:click="set_section('tls')">
                  TrustLines
                </b-nav-item>

                <b-nav-item v-bind:active="section == 'objs'"
                            v-on:click="set_section('objs')">
                  Ledger Entries
                </b-nav-item>
              </b-nav>
            </b-col>

            <b-col v-bind:cols="$mq == 'sm' ? 2 : 4">
              <!--<b-button class="control_button"
                            v-bind:class="$mq"
                            v-on:click="toggle_widget('timeline')"
                            v-bind:pressed="show_timeline">
                Timeline - TODO
              </b-button>-->

              <b-button class="control_button"
                        v-bind:class="$mq"
                        v-on:click="toggle_widget('hour_of_day')"
                        v-bind:pressed="show_hour_of_day">
                By Hour
              </b-button>

              <b-button class="control_button"
                        v-bind:class="$mq"
                        v-on:click="toggle_widget('day_of_week')"
                        v-bind:pressed="show_day_of_week">
                By Day
              </b-button>
            </b-col>
          </b-row>

          <b-row class="widget" v-show="show_timeline">
            <b-col>
              <AccountDetailsTimeline v-bind:txs="txs" />
            </b-col>
          </b-row>

          <b-row class="widget" v-show="show_hour_of_day">
            <b-col class="p-0">
              <AccountDetailsHourOfDay v-bind:txs="txs" />
            </b-col>
          </b-row>

          <b-row class="widget" v-show="show_day_of_week">
            <b-col class="p-0">
              <AccountDetailsDayOfWeek v-bind:txs="txs" />
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <div v-if="section == 'txs'">
                <AccountDetailsTXs v-bind:txs="txs"
                                   v-bind:markers="txs_markers"
                                   v-bind:id="id"
                                   v-on:sync="get_txs" />
              </div>

              <div v-if="section == 'tls'">
                <AccountDetailsTrustLines v-bind:trust_lines="trust_lines"
                                          v-bind:markers="trust_lines_markers"
                                          v-bind:id="id"
                                          v-on:sync="get_trust_lines" />
              </div>

              <div v-if="section == 'objs'">
                <AccountDetailsLedgerObjs v-bind:objs="ledger_objects"
                                          v-bind:markers="ledger_objects_markers"
                                          v-bind:id="id"
                                          v-on:sync="get_ledger_objects" />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AccountDetailsMeta       from './account_details/meta'
import AccountDetailsTags       from './account_details/tags'
import AccountDetailsBalances   from './account_details/balances'
import AccountDetailsTrustLines from './account_details/trust_lines'
import AccountDetailsTXs        from './account_details/txs'
import AccountDetailsLedgerObjs from './account_details/ledger_objs'

import AccountDetailsTimeline   from './account_details/timeline'
import AccountDetailsHourOfDay  from './account_details/hour_of_day'
import AccountDetailsDayOfWeek  from './account_details/day_of_week'

import tags from '../tags'

var CommandDispatcher    = require('../mixins/command_dispatcher')
var AccountDetailsSyncer = require('./account_details/syncer').default

export default {
  name: 'AccountDetails',

  mixins : [CommandDispatcher,
            AccountDetailsSyncer],

  components : {
    AccountDetailsMeta,
    AccountDetailsTags,
    AccountDetailsBalances,

    AccountDetailsTimeline,
    AccountDetailsHourOfDay,
    AccountDetailsDayOfWeek,

    AccountDetailsTrustLines,
    AccountDetailsTXs,
    AccountDetailsLedgerObjs,
  },

  data : function(){
    return {
         show_timeline : false,
      show_hour_of_day : false,
      show_day_of_week : false
    };
  },

  computed : {
    id : function(){
      return this.$store.state.account.id;
    },

    section : {
      get : function(){
        return this.$store.state.account.section;
      },

      set : function(s){
        this.$store.commit('set_account_section', s);
      }
    },

    advisory_level : function(){
      var advisory = tags.advisory_level(this.id);
      if(!advisory) return '';
      return 'advisory' + advisory;
    }
  },


  watch : {
    id : function(){
       this.sync_account();
    }
  },

  methods : {
    set_section : function(section){
      this.section = section;
      switch(section){
        case "txs":
          this.$router.push("/account/"+this.$store.state.account.id+"/txs");
          break;
        case "objs":
          this.$router.push("/account/"+this.$store.state.account.id+"/objs");
          break;
        case "tls":
          this.$router.push("/account/"+this.$store.state.account.id+"/tls");
          break;    
      }
    },

    get_trust_lines : function(page){
      this.sync_trust_lines(page);
    },

    get_txs : function(page){
      this.sync_txs(page);
    },

    get_ledger_objects : function(page){
      this.sync_ledger_objects(page);
    },

    toggle_widget : function(widget){
      if(widget == 'timeline'){
        this.show_timeline = !this.show_timeline;
        this.show_hour_of_day = false;
        this.show_day_of_week = false;

      }else if(widget == 'hour_of_day'){
        this.show_hour_of_day = !this.show_hour_of_day;
        this.show_timeline = false;
        this.show_day_of_week = false;

      }else if(widget == 'day_of_week'){
        this.show_day_of_week = !this.show_day_of_week;
        this.show_hour_of_day = false;
        this.show_timeline = false;
      }
    }
  },

  created : function(){
    this.sync_account();

    if(!this.section)
      this.section = "txs";
  }
}
</script>

<style scoped>
#account-container.sm{
  font-size: 0.8rem;
}

.card{
  height: 100%;
  color: white;
}

.spinner_container{
  margin-top: 10px;
  min-height: unset;
  padding-top: 0;
  padding-bottom: 0;
}

#meta{
  background-color: #5473e8;
  background-image: url("../assets/person2.svg");
  box-shadow: 0 0 6px 0 rgba(84, 115, 232, 0.6);
}

#meta.advisory3{
  background-color: red;
}

#meta.advisory2{
  background-color: orange;
}

#meta.advisory1{
  background-color: #caca00;
}

#tags{
  background-color: #5061b5;
  background-image: url("../assets/notes.svg");
}

#balances{
  background-color: #3bc1cd;
  background-image: url("../assets/money-bag.svg");
}

#details_container{
  background-color: white;
  padding-bottom: 20px;
  margin-top: 20px;
}

#account_sections.sm{
  font-size: 0.7em;
}

.control_button{
  margin: 15px;
  float: right;
}

.control_button.sm{
  margin: 2px;
  padding: 3px;
  font-size: 0.5em;
  width: 100%;
}

.widget{
  margin-left: 1px;
  margin-right: 1px;
}
</style>

<style>
.account_details_card{
  font-size: 1.2em;
}

.account_details_card.sm:last-child{
  margin-top: 15px;
}

.account_details_card.sm{
  padding-left: 10px;
  padding-right: 10px;
}

.account_details_card.sm .content{
  font-size: 0.8em;
}

.account_details_card .subtext{
  color: #dce2fb;
  font-size: 0.7em;
  margin-bottom: 7px;
}

.account_details_card .advisory3 .subtext,
.account_details_card .advisory2 .subtext,
.account_details_card .advisory1 .subtext{
  color: black;
}

.account_details_card .subtext:last-child{
  margin-bottom: 0;
}
</style>
